import React from 'react';
import BarChartIcon from '@mui/icons-material/Equalizer';

const HorizontalBarChartIcon = (
    props: React.ComponentProps<typeof BarChartIcon>,
) => <BarChartIcon {...props} style={{ transform: 'rotate(90deg)' }} />;

export default HorizontalBarChartIcon;
